import { render, staticRenderFns } from "./InvestorInternalMaintenance.vue?vue&type=template&id=d0904f4a&"
import script from "./InvestorInternalMaintenance.vue?vue&type=script&lang=js&"
export * from "./InvestorInternalMaintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
